export const environment = {
    production: true,
    apiUrl: '',
    //RAFs publishable key
    stripe_pk_key: 'pk_live_51IAzNfDqjOHQNnqdmUmvvSyZkbh7y4XYMz84tYVWXzW7zxtuoA6wNmuRdCPtZMOomiTjfJEZudwSvQnMOTbLLkIT00tu9eEMUI'
};
